import Vue from "vue"
import VueRouter from "vue-router"

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return savedPosition
  } else {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
    return { x: 0, y: 0 }
  }
}

export const routes = [
  {
    path: "/",
    name: "hub",
    component: () => import("@hub/landing-page/src/views/LandingPage.vue")
  },
  {
    path: "/contato/:user",
    name: "link-tree",
    component: () => import("@hub/landing-page/src/views/LinkTree.vue")
  },
  {
    path: "/evento/lead",
    name: "lead",
    component: () => import("@hub/landing-page/src/views/EventLead.vue")
  }
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior
})

export default router
